export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-dpd.ef826a90.svg","height":40,"width":100,"blurWidth":0,"blurHeight":0};